/* import __COLOCATED_TEMPLATE__ from './session-overview.hbs.js'; */
import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { cached, tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { task, restartableTask, dropTask } from 'ember-concurrency';
import { DateTime } from 'luxon';
import { validatable, Length, Gte, NotBlank } from 'ilios-common/decorators/validation';
import { hash } from 'rsvp';
import { findById, sortBy } from 'ilios-common/utils/array-helpers';
import { TrackedAsyncData } from 'ember-async-data';
let SessionOverview = (_dec = Length(3, 200), _dec2 = NotBlank(), _dec3 = Length(3, 65000), _dec4 = NotBlank(), _dec5 = Gte(0), _dec6 = Length(3, 65000), validatable(_class = (_class2 = class SessionOverview extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "currentUser", _descriptor, this);
    _initializerDefineProperty(this, "router", _descriptor2, this);
    _initializerDefineProperty(this, "permissionChecker", _descriptor3, this);
    _initializerDefineProperty(this, "intl", _descriptor4, this);
    _initializerDefineProperty(this, "store", _descriptor5, this);
    _initializerDefineProperty(this, "title", _descriptor6, this);
    _initializerDefineProperty(this, "instructionalNotes", _descriptor7, this);
    _initializerDefineProperty(this, "hours", _descriptor8, this);
    _initializerDefineProperty(this, "description", _descriptor9, this);
    _initializerDefineProperty(this, "sessionType", _descriptor10, this);
    _initializerDefineProperty(this, "isSaving", _descriptor11, this);
    _initializerDefineProperty(this, "isEditingPostRequisite", _descriptor12, this);
    _initializerDefineProperty(this, "updatedAt", _descriptor13, this);
    _initializerDefineProperty(this, "showCopy", _descriptor14, this);
    _initializerDefineProperty(this, "sessionTypes", _descriptor15, this);
    _initializerDefineProperty(this, "showAttendanceRequired", _descriptor16, this);
    _initializerDefineProperty(this, "showSupplemental", _descriptor17, this);
    _initializerDefineProperty(this, "showSpecialAttireRequired", _descriptor18, this);
    _initializerDefineProperty(this, "showSpecialEquipmentRequired", _descriptor19, this);
    _initializerDefineProperty(this, "isIndependentLearning", _descriptor20, this);
    _defineProperty(this, "load", _buildTask(() => ({
      context: this,
      generator: function* (element, [session]) {
        const course = yield session.course;
        const school = yield course.school;
        const sessionTypes = yield school.sessionTypes;
        const {
          ilmSession,
          sessionType,
          showCopy,
          showSessionAttendanceRequired,
          showSessionSupplemental,
          showSessionSpecialAttireRequired,
          showSessionSpecialEquipmentRequired
        } = yield hash({
          course: session.course,
          ilmSession: session.ilmSession,
          sessionType: session.sessionType,
          showCopy: this.getShowCopy(session),
          showSessionAttendanceRequired: school.getConfigValue('showSessionAttendanceRequired'),
          showSessionSupplemental: school.getConfigValue('showSessionSupplemental'),
          showSessionSpecialAttireRequired: school.getConfigValue('showSessionSpecialAttireRequired'),
          showSessionSpecialEquipmentRequired: school.getConfigValue('showSessionSpecialEquipmentRequired')
        });
        this.showCopy = showCopy;
        this.showAttendanceRequired = showSessionAttendanceRequired;
        this.showSupplemental = showSessionSupplemental;
        this.showSpecialAttireRequired = showSessionSpecialAttireRequired;
        this.showSpecialEquipmentRequired = showSessionSpecialEquipmentRequired;
        this.sessionType = sessionType;
        this.title = session.title;
        this.instructionalNotes = session.instructionalNotes;
        if (ilmSession) {
          this.hours = ilmSession.hours;
          this.isIndependentLearning = true;
        } else {
          this.isIndependentLearning = false;
        }
        this.updatedAt = DateTime.fromJSDate(session.updatedAt).toFormat('D t');
        this.sessionTypes = sessionTypes || [];
        this.description = session.description;
      }
    }), null, "load", "restartable"));
    _defineProperty(this, "saveIndependentLearning", _buildTask(() => ({
      context: this,
      generator: function* (value) {
        this.isIndependentLearning = value;
        if (!value) {
          const ilmSession = yield this.args.session.ilmSession;
          this.args.session.set('ilmSession', null);
          yield ilmSession.destroyRecord();
          yield this.args.session.save();
        } else {
          const hours = 1;
          const dueDate = DateTime.now().plus({
            week: 6
          }).set({
            hour: 17,
            minute: 0
          }).toJSDate();
          this.hours = hours;
          const ilmSession = this.store.createRecord('ilm-session', {
            session: this.args.session,
            hours,
            dueDate
          });
          this.args.session.set('ilmSession', yield ilmSession.save());
          yield this.args.session.save();
        }
      }
    }), null, "saveIndependentLearning", "drop"));
    _defineProperty(this, "saveDescription", _buildTask(() => ({
      context: this,
      generator: function* () {
        this.addErrorDisplayFor('description');
        const isValid = yield this.isValid('description');
        if (!isValid) {
          return false;
        }
        this.removeErrorDisplayFor('description');
        this.args.session.description = this.description;
        yield this.args.session.save();
      }
    }), null, "saveDescription", null));
    _defineProperty(this, "saveInstructionalNotes", _buildTask(() => ({
      context: this,
      generator: function* () {
        this.addErrorDisplayFor('instructionalNotes');
        const isValid = yield this.isValid('instructionalNotes');
        if (!isValid) {
          return false;
        }
        this.removeErrorDisplayFor('instructionalNotes');
        this.args.session.instructionalNotes = this.instructionalNotes;
        yield this.args.session.save();
      }
    }), null, "saveInstructionalNotes", null));
  }
  get hasErrorForInstructionalNotesData() {
    return new TrackedAsyncData(this.hasErrorFor('instructionalNotes'));
  }
  get hasErrorForInstructionalNotes() {
    return this.hasErrorForInstructionalNotesData.isResolved ? this.hasErrorForInstructionalNotesData.value : false;
  }
  get hasErrorForDescriptionData() {
    return new TrackedAsyncData(this.hasErrorFor('description'));
  }
  get hasErrorForDescription() {
    return this.hasErrorForDescriptionData.isResolved ? this.hasErrorForDescriptionData.value : false;
  }
  get prerequisitesData() {
    return new TrackedAsyncData(this.args.session.prerequisites);
  }
  get postrequisiteData() {
    return new TrackedAsyncData(this.args.session.postrequisite);
  }
  get postrequisiteCourseData() {
    return new TrackedAsyncData(this.postrequisite?.course);
  }
  get ilmSessionData() {
    return new TrackedAsyncData(this.args.session.ilmSession);
  }
  get prerequisites() {
    return this.prerequisitesData.isResolved ? this.prerequisitesData.value : null;
  }
  get postrequisite() {
    return this.postrequisiteData.isResolved ? this.postrequisiteData.value : null;
  }
  get postrequisiteCourse() {
    return this.postrequisiteCourseData.isResolved ? this.postrequisiteCourseData.value : null;
  }
  get ilmSession() {
    return this.ilmSessionData.isResolved ? this.ilmSessionData.value : null;
  }
  get filteredSessionTypes() {
    const selectedSessionTypeId = isEmpty(this.sessionType) ? -1 : this.sessionType.id;
    return this.sessionTypes.filter(sessionType => {
      return sessionType.active || sessionType.id === selectedSessionTypeId;
    });
  }
  get sortedSessionTypes() {
    return sortBy(this.filteredSessionTypes, 'title');
  }
  /**
   * Check if a user is allowed to create a session anywhere
   * Try and do this by loading as little data as possible, but in the
   * end we do need to check every course in the school.
   */
  async getShowCopy(session) {
    if (this.router.currentRouteName === 'session.copy') {
      return false;
    }
    const course = await session.course;
    if (await this.permissionChecker.canCreateSession(course)) {
      return true;
    }
    const user = await this.currentUser.getModel();
    const allRelatedCourses = await user.allRelatedCourses;
    let relatedCourse;
    for (relatedCourse of allRelatedCourses) {
      if (await this.permissionChecker.canCreateSession(relatedCourse)) {
        return true;
      }
    }
    const school = await course.school;
    const schoolCourses = await school.courses;
    let schoolCourse;
    for (schoolCourse of schoolCourses) {
      if (await this.permissionChecker.canCreateSession(schoolCourse)) {
        return true;
      }
    }
    return false;
  }
  async changeTitle() {
    this.addErrorDisplayFor('title');
    const isValid = await this.isValid('title');
    if (!isValid) {
      return false;
    }
    this.removeErrorDisplayFor('title');
    this.args.session.title = this.title;
    await this.args.session.save();
  }
  revertTitleChanges() {
    this.title = this.args.session.title;
  }
  revertInstructionalNotesChanges() {
    this.instructionalNotes = this.args.session.instructionalNotes;
  }
  setSessionType(event) {
    this.sessionType = findById(this.sessionTypes, event.target.value);
  }
  changeSessionType() {
    this.args.session.sessionType = this.sessionType;
    this.args.session.save();
  }
  async revertSessionTypeChanges() {
    this.sessionType = await this.args.session.sessionType;
  }
  changeSupplemental(value) {
    this.args.session.supplemental = value;
    this.args.session.save();
  }
  changeSpecialEquipment(value) {
    this.args.session.equipmentRequired = value;
    this.args.session.save();
  }
  changeSpecialAttire(value) {
    this.args.session.attireRequired = value;
    this.args.session.save();
  }
  changeAttendanceRequired(value) {
    this.args.session.attendanceRequired = value;
    this.args.session.save();
  }
  async changeIlmHours() {
    this.addErrorDisplayFor('hours');
    const isValid = await this.isValid('hours');
    if (!isValid) {
      return false;
    }
    this.removeErrorDisplayFor('hours');
    const ilmSession = await this.args.session.ilmSession;
    if (ilmSession) {
      ilmSession.hours = this.hours;
      await ilmSession.save();
    }
  }
  async revertIlmHoursChanges() {
    const ilmSession = await this.args.session.ilmSession;
    if (ilmSession) {
      this.hours = ilmSession.hours;
    }
  }
  changeDescription(html) {
    this.addErrorDisplayFor('description');
    const noTagsText = html.replace(/(<([^>]+)>)/gi, '');
    const strippedText = noTagsText.replace(/&nbsp;/gi, '').replace(/\s/g, '');

    //if all we have is empty html then save null
    if (strippedText.length === 0) {
      html = null;
    }
    this.description = html;
  }
  revertDescriptionChanges() {
    this.description = this.args.session.description;
  }
  changeInstructionalNotes(html) {
    this.addErrorDisplayFor('instructionalNotes');
    const noTagsText = html.replace(/(<([^>]+)>)/gi, '');
    const strippedText = noTagsText.replace(/&nbsp;/gi, '').replace(/\s/g, '');

    //if all we have is empty html then save null
    if (strippedText.length === 0) {
      html = null;
    }
    this.instructionalNotes = html;
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "currentUser", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "permissionChecker", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "title", [_dec, _dec2, tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "instructionalNotes", [_dec3, tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "hours", [_dec4, _dec5, tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "description", [_dec6, tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "sessionType", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "isSaving", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, "isEditingPostRequisite", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, "updatedAt", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class2.prototype, "showCopy", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class2.prototype, "sessionTypes", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class2.prototype, "showAttendanceRequired", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class2.prototype, "showSupplemental", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class2.prototype, "showSpecialAttireRequired", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class2.prototype, "showSpecialEquipmentRequired", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class2.prototype, "isIndependentLearning", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "hasErrorForInstructionalNotesData", [cached], Object.getOwnPropertyDescriptor(_class2.prototype, "hasErrorForInstructionalNotesData"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasErrorForDescriptionData", [cached], Object.getOwnPropertyDescriptor(_class2.prototype, "hasErrorForDescriptionData"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "prerequisitesData", [cached], Object.getOwnPropertyDescriptor(_class2.prototype, "prerequisitesData"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "postrequisiteData", [cached], Object.getOwnPropertyDescriptor(_class2.prototype, "postrequisiteData"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "postrequisiteCourseData", [cached], Object.getOwnPropertyDescriptor(_class2.prototype, "postrequisiteCourseData"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "ilmSessionData", [cached], Object.getOwnPropertyDescriptor(_class2.prototype, "ilmSessionData"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "changeTitle", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "changeTitle"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "revertTitleChanges", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "revertTitleChanges"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "revertInstructionalNotesChanges", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "revertInstructionalNotesChanges"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "setSessionType", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "setSessionType"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "changeSessionType", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "changeSessionType"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "revertSessionTypeChanges", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "revertSessionTypeChanges"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "changeSupplemental", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "changeSupplemental"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "changeSpecialEquipment", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "changeSpecialEquipment"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "changeSpecialAttire", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "changeSpecialAttire"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "changeAttendanceRequired", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "changeAttendanceRequired"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "changeIlmHours", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "changeIlmHours"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "revertIlmHoursChanges", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "revertIlmHoursChanges"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "changeDescription", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "changeDescription"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "revertDescriptionChanges", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "revertDescriptionChanges"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "changeInstructionalNotes", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "changeInstructionalNotes"), _class2.prototype), _class2)) || _class);
export { SessionOverview as default };